<template>
  <div class="forex-index">
    <page-navigate></page-navigate>

    <div class="forex-wrapper cn">
      <forexMenu />
      <div class="forex-wrapper-body">

        <section class="section1">
          <h1 class="">市场年鉴与期刊</h1>
          <p class="forex-title-intro">
            汇聚EBC研究团队出品的权威市场年鉴与深度期刊，覆盖黄金、原油与外汇等主要资产门类。
          </p>
          <div class="book-list-wrapper">
            <div class="book-list">
                <div class="book-item" v-for="book in bookList" :key="book.id">
                  <a :href="book.url.replace('/zh-cn', '')" class="img-box">
                    <img class="book-item-img" :src="book.thumbnail"
                                            :alt="book.post_short_title" />
                  </a>
                  <div class="book-item-content">
                    <a :href="book.url.replace('/zh-cn', '')" class="book-item-name">{{book.post_short_title}}</a>
                    <div class="book-item-intro">{{book.post_excerpt}}</div>
                  </div>
                </div>
            </div>
          </div>
        </section>


      </div>
    </div>

    <page-footer></page-footer>
  </div>
</template>
<script>
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getAcademyBulletin } from '../../serve/forex.js';

export default {
  components: {
    forexMenu
  },
  data() {
    return {
      bookList: [],
    }
  },
  created() {
    getAcademyBulletin().then(response => {
      if (response.status && response.status == '200') {
        this.bookList = response.data.data
      }

    }).catch(err => {
      this.bookList = []
    })
  },
  mounted() {

  }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
  font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.swiper-container {
  overflow: hidden;
}

section+section {
  margin-top: 88rem;
}

.section1 {
  margin-top: 0;
}

.book-global-list-wrapper,
.book-list-wrapper {
  margin-top: 48rem;
}

.book-list {
  display: flex;
  flex-wrap: wrap;
  gap: 56rem 32rem;
}

.book-item {
  display: block;
  width: calc(25% - 24rem);
}

.img-box {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 285rem;
  border-radius: 46rem;
  overflow: hidden;
}

.img-box::before {
  position: absolute;
  left: 0;
  bottom: 0;
  content: "";
  width: 100%;
  height: 210rem;
  background-color: #f9f6f2;
  border-radius: 46rem 50% 46rem 46rem;
  z-index: -1;
  transition: all 0.47s;
}

.img-box::after {
  position: absolute;
  right: 0;
  top: 50rem;
  font-family: "iconfont" !important;
  content: "\e616";
  font-size: 40rem;
  z-index: -1;
  transition: all 0.47s;
  color: #f9f6f2;
}

.book-item-img {
  height: 100%;
  width: auto;
  object-fit: cover;
}

.book-item:hover .book-item-img {}

.book-item:hover .img-box::before {
  background-color: #e6ddcf;
  /* height: 266rem; */
}

.book-item:hover .img-box::after {
  color: #a52933;
  transform: rotateY(180deg);
}

.book-item-content {
  margin-top: 32rem;
}

.book-item-name {
  display: block;
  color: #232222;
  font-size: 20rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 溢出时显示省略号 */
}

.book-item-name:hover {
  color: #232222;
}

.book-item-intro {
  margin-top: 7rem;
  color: #6a6967;
  font-family: "Source Han Sans CN";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: -webkit-box;
  /* 关键：使用弹性盒模型 */
  -webkit-box-orient: vertical;
  /* 垂直方向排列 */
  -webkit-line-clamp: 1;
  /* 限制显示2行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 超出显示... */
}

.book-btn-text {
  margin-top: 16rem;
  display: inline-block;
  margin-top: 5rem;
  color: #b2afad;
  font-size: 14rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.book-btn-text::after {
  font-family: "iconfont" !important;
  content: "\e624";
  color: #b2afad;
  font-size: 14rem;
  margin-left: 4rem;
  line-height: normal;
}

.book-item:hover .book-btn-text::after,
.book-item:hover .book-btn-text {
  color: #a52933;
}

@media (max-width: 996px) {
  .book-list {
    gap: 88rem 40rem;
  }

  .book-item {
    width: calc(50% - 20rem);
  }

  .img-box {
    height: 317rem;
  }

  .img-box::before {
    height: 210rem;
  }

  .book-item:hover .img-box::before {
    height: 224rem;
  }

  .book-item-name {
    font-size: 32rem;
  }

  .book-item-intro {
    font-size: 28rem;
  }

  .book-btn-text {
    margin-top: 28rem;
  }

  .book-btn-text::after,
  .book-btn-text {
    font-size: 28rem;
  }
}
</style>